<template>
  <div class="all">
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <!-- 关键词检索  -->
    <div
      class="width100 margin-auto backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="80px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="关键词">
          <el-input placeholder="请输入关键词" v-model="input"></el-input>
        </el-form-item>
        <div class="pad-left20">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()" class="resetbtn">重 置</el-button>
        </div>
      </el-form>
      <span
        class="
          attention
          margin-top10 margin-bot10 margin-left20 margin-right20
          f14
        "
        @click="toproductaddfication()"
        >新 增</span
      >
    </div>

    <el-skeleton
      class="width100 margin-top15"
      :loading="loading"
      animated
      :throttle="500"
      v-if="total != 0"
    >
      <template slot="template">
        <div
          class="width100 margin-auto backwhite pad-top20 border-rd3 alldigital"
        >
          <el-table :data="page" stripe class="eltable width98 margin-auto f14">
            <el-table-column label="作品名称" align="left"
              ><template slot-scope="scope">
                <span
                  @click="todetails(scope.row)"
                  class="bluecolor cursorpointer"
                  >{{ scope.row.title }}</span
                ></template
              ></el-table-column
            >

            <el-table-column
              label="上传时间"
              align="center"
              prop="create_time"
            />
            <el-table-column
              label="操作"
              align="center"
              class-name="small-padding fixed-width"
            >
              <template slot-scope="scope">
                <div class="cursorpointer">
                  <span style="color: #52c5cb" @click="todetails(scope.row)"
                    >详情</span
                  >
                  <span
                    class="pad-left10"
                    style="color: #52c5cb"
                    @click="tomodify(scope.row)"
                    >修改</span
                  >
                  <span
                    class="pad-left10"
                    style="color: #52c5cb"
                    @click="removepro(scope.row)"
                    >删除</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div
            v-if="total != 0"
            class="
              flex-betweennowrap
              width99
              margin-auto
              pad-top20 pad-bot20
              pagination
            "
          >
            <span></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </el-skeleton>
    <div
      class="width100 margin-auto backgroudFFF margin-top15"
      v-if="total == 0"
    >
      <el-empty
        :image="require('@/assets/barsvg/zwsj@3x.png')"
        :image-size="200"
        description="抱歉，没有搜到您想要的内容"
        class="heightempty"
        ><p style="position: relative; bottom: 60px" class="f14">
          暂无数据
        </p></el-empty
      >
    </div>
    <!-- 工业设计新增 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleadd"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <industrialadd></industrialadd>
    </el-dialog>
    <!-- 工业设计详情 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibledetily"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
    >
      <industrialdetail></industrialdetail>
    </el-dialog>
    <!-- 工业设计修改 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblemodify"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="width100 margin-auto">
        <div class="Retrieveform">
          <div class="f16 width98 textalign-left dimensional">工业设计修改</div>
          <div class="pad-top30">
            <p class="textalign-left pad-bot10">项目名称</p>
            <el-input
              placeholder="请输入项目名称"
              v-model="title"
              class="width100"
            ></el-input>
          </div>
          <div class="pad-top20">
            <p class="textalign-left pad-bot10">项目类别</p>
            <el-select
              class="width100"
              v-model="cate_id"
              placeholder="请选择项目类别"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in options"
                :key="item.i"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="pad-top20">
            <p class="textalign-left pad-bot10">项目备注</p>
            <el-input
              placeholder="请输入项目备注"
              type="textarea"
              :autosize="autosize"
              v-model="remark"
              class="width100"
            ></el-input>
          </div>
          <div class="textalign-right pad-top20">
            <el-button @click="dialogVisiblemodify = false">取 消</el-button>
            <el-button
              class="margin-top20"
              type="primary"
              @click="toaddPersonnel()"
            >
              保 存
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import {
  entdesignproductindex,
  entdesignproductdelete,
} from "@/api/newhead/newhead.api";
import BUS from "@/BUS/BUS";
import callback from "@/components/callback.vue";
import industrialadd from "./industrial-addfication.vue";
import {
  entdesignproductdetail,
  entdesignproductupdate,
  entdesignproductcate,
} from "@/api/newhead/newhead.api";
import switchcore from "@/components/switchcore.vue";
import industrialdetail from "./industrial-detail.vue";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibleadd: false,
      dialogVisiblemodify: false,
      dialogVisibledetily: false,
      serchkey: true,
      ruleForm: {
        pipo: "",
        name: "",
      },
      thisNum: 1,
      page: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      input: "",
      form: {},
      title: "",
      cate_id: "",
      remark: "",
      id: "",
      options: [],
      pageval: "",
    };
  },
  components: {
    callback,
    industrialadd,
    switchcore,
    industrialdetail,
  },
  methods: {
    toaddPersonnel() {
      entdesignproductupdate({
        cate_id: this.cate_id,
        title: this.title,
        remark: this.remark,
        id: this.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          this.dialogVisiblemodify = false;
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    //   产品添加
    toproductaddfication() {
      this.dialogVisibleadd = true;
    },
    // 删除
    removepro(row) {
      this.$confirm("此操作将删除此作品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entdesignproductdelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 修改
    tomodify(row) {
      this.dialogVisiblemodify = true;
      // 获取项目详情
      entdesignproductdetail({ id: row.id }).then((res) => {
        if (res.data.code == 200) {
          this.title = res.data.data.title;
          this.cate_id = res.data.data.cate_id;
          this.remark = res.data.data.remark;
          this.id = res.data.data.id;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });

      entdesignproductcate({}).then((res) => {
        this.options = res.data.data;
      });
    },
    //详情
    todetails(row) {
      window.sessionStorage.setItem("productmodification", row.id);
      BUS.$emit("productmodification", row.id);
      this.dialogVisibledetily = true;
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      entdesignproductindex({
        page: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      entdesignproductindex({
        page: 1,
        limit: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.input = null;
      this.thisNum = 1;
      entdesignproductindex({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    submitForm() {
      entdesignproductindex({
        _keywords: this.input,
        page: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;

          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      entdesignproductindex({
        _keywords: this.input,
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    entdesignproductindex({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;

        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("indusdesign", (data) => {
      if (data == 1) {
        this.refresh();
        this.dialogVisibleadd = false;
        this.dialogVisibledetily = false;
      } else {
        this.dialogVisibleadd = false;
        this.dialogVisibledetily = false;
      }
    });
  },
};
</script>
<style scoped>
.editor >>> .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 13px;
}
.preservation {
  background: #409eff;
  color: white;
  width: 80px;
  text-align: center;
  border-radius: 5px;
  line-height: 30px;
  float: right;
  font-size: 14px;
}
.doc {
  color: #ffb452;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>